import { render, staticRenderFns } from "./TextCard.vue?vue&type=template&id=b9c7b4d8&"
import script from "./TextCard.vue?vue&type=script&lang=js&"
export * from "./TextCard.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports